/**
 * 商标 商标列表
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <!-- <el-breadcrumb-item>公司管理</el-breadcrumb-item> -->
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.business_name" placeholder="请输入企业名称" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
        <!-- <el-button size="small" type="primary" icon="el-icon-folder-add" title="批量导入企业信息" @click="handleImport()">导入</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-folder-remove" title="导出满足搜索条件的所有数据" @click="exportSearch()">导出</el-button>
        <!-- <el-button size="small" type="danger" icon="el-icon-delete" title="批量删除勾选的企业信息" @click="handleEdit()">删除</el-button> -->
      </el-form-item>
      <span style="float: right;font-size: 14px;line-height: 40px;">搜索结果：<span style="color: #F56C6C;">{{ searchTotal }}条</span></span>
    </el-form>
    <div style="display: flex;font-size: 1rem;">
      <div class="search-sidebar" v-if="isRefresh">
        <div v-if="ifCollapseOperate">
          <div v-for="(item,index) in collapseOperate" :key="index" style="border:1px solid  #a9d5de;margin: 12px;padding: 15px;background-color: #F8FFFF;display: flex;">
            <div>
              <span style="color: #276F86;">{{ item.event }}</span>
              <span>{{ item.type }}</span>
              <span style="color: #276F86;">({{ item.value }})</span>
            </div>
            <i class="el-dialog__close el-icon el-icon-close" style="cursor: pointer;" @click="delCollapseOperate(index)"></i>
          </div>
        </div>
        <el-collapse style="border: 0px;">
          <div @click="collapseMarkStatus">
            <el-collapse-item title="商标状态" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseStatusLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseStatusCheckList">
                    <el-checkbox v-for="item in collapseMarkStatusArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentStatusFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentStatusPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
          <div @click="collapseApplicant">
            <el-collapse-item title="申请人" style="margin: 15px 0px 10px 10px;">
              <div v-loading="collapseApplicantLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseApplicantCheckList" class="applicantGroup">
                    <el-checkbox v-for="item in collapseApplicantArr" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentApplicantFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentApplicantPerk()">过滤</el-button>
                </div>
              </div>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
    <!--列表-->
      <div style="margin-left: 15px;width: 90%;">
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <!-- <el-table-column align="center" prop="business_ein" label="商标">
          </el-table-column> -->
          <el-table-column prop="tm_pic" align="center" label="商标" width="80px">
            <template slot-scope="scope" v-if="scope.row.tm_pic">
              <viewer>
                <!-- <img style="max-height: 135px;cursor: pointer;" :src="item.imagePath"> -->
                <img :src="scope.row.tm_pic" width="60" height="60" />
              </viewer>
            <!-- 　  <img :src="scope.row.tm_pic" width="60" height="60" /> -->
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tm_name" label="商标名称">
          </el-table-column>
          <el-table-column align="center" prop="applicant_cn" label="申请人">
          </el-table-column>
          <el-table-column align="center" prop="reg_no" label="注册号">
          </el-table-column>
          <el-table-column align="center" prop="int_cls" label="国际分类">
          </el-table-column>
          <el-table-column align="center" prop="status" label="商标状态">
          </el-table-column>
          <el-table-column align="center" prop="app_date" label="申请时间">
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <div class="markDialog">
        <div>
          <span style="font-size: 16px;font-weight: bold;">商标基础信息</span>
          <table class="modal-table -striped-col" style="margin-top: 10px;">
            <!-- <tr>
              <td width="20%">商标</td>
              <td colspan="3"></td>
            </tr> -->
            <tr>
              <td width="20%">商标名称</td>
              <td colspan="3">{{ markInfo.tmName }}</td>
            </tr>
            <tr>
              <td width="20%">申请/注册号</td>
              <td width="30%">{{ markInfo.reg_no }}</td>
              <td width="20%">国际分类</td>
              <td width="30%">{{ markInfo.clsStr }}</td>
            </tr>
            <tr>
              <td width="20%">商标状态</td>
              <td width="30%">{{ markInfo.statusStr }}</td>
              <td width="20%">申请日期</td>
              <td width="30%">{{ markInfo.appDate }}</td>
            </tr>
            <tr>
              <td width="20%">商标类型</td>
              <td width="30%">{{ markInfo.categoryStr }}</td>
              <td width="20%">是否共有商标</td>
              <td width="30%">{{ markInfo.isShared }}</td>
            </tr>
            <tr>
              <td width="20%">申请人名称</td>
              <td width="30%">{{ markInfo.applicantCn }}</td>
              <td width="20%">申请人地址</td>
              <td width="30%">{{ markInfo.addressCn }}</td>
            </tr>
            <tr>
              <td width="20%">代理/办理机构</td>
              <td colspan="3">{{ markInfo.agent}}</td>
            </tr>
          </table>
        </div>
        <div style="margin-top: 30px;">
          <span style="font-size: 16px;font-weight: bold;">商品/服务项目</span>
          <div style="margin-top: 10px;border: 1px solid #E4EEF6;padding: 9px;">
            <div v-for="goodsItem in markInfo.goodsList">
              {{ goodsItem.title }}({{ goodsItem.code }})
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 企业信息导入界面 -->
     <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="importFormVisible" width="50%" @click="closeDialog('importForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M<button @click="downloadImport()" style="margin-left: 15px;cursor: pointer">下载模板</button></div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getBusinessList, 
  editBusiness, 
  delBusiness, 
  webUrl, 
  getTradeMarkList,
  getTradeMarkFilter, 
  getMarkStatusGroup,
  getApplicantGroup,
  exportSearchMark,
  getTradeMarkInfo } from '../../api/patentMG'
import { checkLogin } from '../../utils/util'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      importFormVisible: false, //控制导入页面显示与隐藏
      searchTotal: 0,
      isRefresh: true,//左侧是否需要刷新
      collapseOperateApi: [],//折叠面板筛选或过滤事件传递值
      collapseOperate: [],// 折叠面板筛选或过滤事件
      ifCollapseOperate: false,// 折叠面板筛选或过滤事件是否存在
      ifCollapseMarkStatus: true,// 折叠面板商标状态是否需要查询
      collapseStatusLoading: true,// 折叠面板商标状态是否显示加载
      collapseMarkStatusArr: [],// 折叠面板商标状态筛选数据
      collapseStatusCheckList: [],// 折叠面板商标状态勾选数据
      ifCollapseApplicant: true,// 折叠面板商标申请人是否需要查询
      collapseApplicantLoading: true,// 折叠面板商标申请人是否显示加载
      collapseApplicantArr: [],// 折叠面板商标申请人筛选数据
      collapseApplicantCheckList: [],// 折叠面板商标申请人勾选数据

      title: '添加',
      editForm: {
        id: '',
        business_name: '',
        business_ein: '',
        username: '',
        mobile: ''
      },
      // rules表单验证
      rules: {
        business_name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        business_ein: [
          { required: true, message: '请输入企业税号', trigger: 'blur' }
        ],
        username: [
        { required: true, message: '请输入企业负责人', trigger: 'blur' }
        ],
        mobile: [
        { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
      },
      formInline: {
        page: 1,
        ps: 10,
        business_name: ''
      },
      // 商标详情数据
      markInfo: {

      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/patent/business/importBusiness',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.importFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取商标列表(base)
    getdata(parameter) {
      this.loading = true
      getTradeMarkList(parameter)
      .then(res=>{
          res = checkLogin(res);
          if(res.code == 200){
              this.loading = false
              this.listData = res.data.dataList
               // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
      })
    },
    // 商标列表(filter模式)
    getFilter(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      getTradeMarkFilter(parameter)
      .then(res=>{
          res = checkLogin(res);
          if(res.code == 200){
              this.loading = false
              this.listData = res.data.dataList
               // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      // this.getdata(this.formInline)
      this.getFilter()
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getFilter()
      this.isRefresh = true
      this.ifCollapseOperate = true
    },
    //显示编辑界面
    handleEdit: function(index, row) {
     let param = {
      mark_id: row.id,
      intCls: row.int_cls,
      regNo: row.reg_no
     }
     getTradeMarkInfo(param)
     .then(res=>{
      if(res.code == 200){
        this.markInfo = res.data
        this.editFormVisible = true
      }else{
        this.$message({
          type: 'error',
          message: res.msg
        })
      }
     })
    },

     //显示导入界面
    handleImport: function(index, row) {
      this.title = '企业信息导入'
      this.importFormVisible = true
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          editBusiness(this.editForm)
            .then(res => {
              res = checkLogin(res)
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('系统错误,请稍后再试!')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteBusiness(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delBusiness({id:row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统错误,请稍后再试!')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 下载企业信息导入模板
    downloadImport() {
      console.log(999)
    },
    // 删除筛选或过滤项
    delCollapseOperate(index){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      collapseOperate.splice(index,1)
      collapseOperateApi.splice(index,1)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      if(this.collapseOperate.length <= 0){
        this.ifCollapseOperate = false
      }
      console.log(this.collapseOperate)
      // 执行删除后的操作
      // 查询筛选条件
      this.getFilter()
    },
     // 点击获取折叠面板商标状态数据
    collapseMarkStatus(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapseMarkStatus
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getMarkStatusGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseMarkStatusArr = res.data
             that.collapseStatusLoading = false
             that.ifCollapseMarkStatus = false
          }
        })
      }
    },
    // 商标状态筛选
    patentStatusFilter(){
      let checkList = this.collapseStatusCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '商标状态',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'status',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '商标状态',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'status',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseStatusCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 商标状态过滤
    patentStatusPerk(){
      let checkList = this.collapseStatusCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '商标状态',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'status',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '商标状态',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'status',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseStatusCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 点击获取折叠面板商标申请人数据
    collapseApplicant(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapseApplicant
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        getApplicantGroup(parameter)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
             that.collapseApplicantArr = res.data
             that.collapseApplicantLoading = false
             that.ifCollapseApplicant = false
          }
        })
      }
    },
     // 申请人筛选
    patentApplicantFilter(){
      let checkList = this.collapseApplicantCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '申请人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'applicant_cn',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '申请人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicant_cn',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseApplicantCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 申请人过滤
    patentApplicantPerk(){
      let checkList = this.collapseApplicantCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '申请人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'applicant_cn',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '申请人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicant_cn',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseApplicantCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 左侧筛选或过滤查询
    getFilterData(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      getTradeMarkFilter(parameter)
       .then(res => {
        this.loading = false
        if(res.code == 200){
          this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
      })
    },
     //局部刷新
    reload () {
			this.isRefresh = false;
			this.$nextTick(() => {
				this.isRefresh = true
        this.ifCollapseMarkStatus = true
        this.collapseStatusLoading = true
        this.ifCollapseApplicant = true
        this.collapseApplicantLoading = true
        
			})
		},
    // 导出满足搜索条件的所有数据
    exportSearch(){
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      this.$confirm('确定导出所有满足条件的数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(()=>{
        exportSearchMark(parameter)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: '数据导出成功!'
            })
            window.location.href = res.data.url
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(name) {
      if(name == 'editForm'){
        this.editFormVisible = false
      }else if(name == 'importForm'){
        this.importFormVisible = false
      }
      
    }
  }
}
</script>

<style scoped>
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
 }
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;

}
.el-form-item {
    margin-bottom: 10px;
}
.el-input{
  color: #606266;
  width: auto;

}
.export_scope input{
  width: 60px;
}
.aboutDialog >>> .el-dialog__body{
  padding: 0px !important;
  padding:15px !important;
}
.aboutDialog >>> .el-dialog__header {
  padding: 10px 20px;
  height: 25px;
  line-height: 25px;
  text-align: left;
  background: #F8F8F8;
  border-bottom: solid 1px #eee;
}
.aboutDialog >>> .el-dialog__title {
  color: #333;
  font-size: 14px;
}
.aboutDialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #333;
}
.search-sidebar {
  width: 10%;
  border: solid 1px #EBEEF5;
  /* margin-left: 15px; */
  min-width: 200px;
  font-size: 14px;
}
.search-sidebar .item {
  display: block;
  font-weight: 400;
  margin: 15px 10px;
}
.filter_btn {
  color: #21BA45;
  border: solid 1px #21BA45;
  padding: 6px 6px;
}
.perk_btn {
  color: #DB2828;
  border: solid 1px #DB2828;
  padding: 6px 6px;
}
.patentInfoBase .el-form-item{
  margin-bottom: 0px;
}
.search-sidebar .el-collapse {
  border-bottom: 0px solid #EBEEF5;;
}
.leftCheckbox >>>.el-checkbox__input {
  position: absolute;
  top: 2px;
  left: 0;
}
.leftCheckbox >>>.el-checkbox__label {
  min-width: 130px;
  max-width: 160px;
  display: inline-block;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 19px;
  font-size: 14px;
  padding-left: 20px;
}
.content-item {
  margin-bottom: 2px;
}
.content-label {
  color: #808080;
}
ul {
  list-style: none;
  margin-left: -20px;
  font-size: 12px;
  line-height: 2;
}
.patent-info-column {
  width: 100px;
  display: inline-block;
}
.patent-info-number {
  width: 200px;
  display: inline-block;
}
/* .searchTable > tr {
  height: 40px;
} */
.searchTable .label {
  width: 80px;
  min-width: 80px;
}
.searchTable .select {
  width: 350px;
  min-width: 350px;
}
.searchTable .el-form-item {
  margin-bottom: 5px;
}
.searchTable >>>.el-form-item__label {
  font-weight: 600;
}
.searchTable >>>.el-form-item__content {
  line-height: 20px;
}
.el-dialog-div {
  height: 60vh;
  overflow-x: hidden;
}
.legalContent {
  border: solid 1px #b3b1b1;
  padding: 5px 5px;
  border-radius: 5px;
}
.applicantGroup {
  max-height: 450px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.applicantGroup::-webkit-scrollbar {
    width: 4px;
  }
.applicantGroup::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  /* background: fade(#409EFF, 60%); */
}
.applicantGroup::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* background: fade(@primary-color, 30%); */
}
.modal-table {
    color: #333;
    font-size: 14px;
    max-width: 100%;
    text-align: left;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
}
.modal-table.-striped-col {
    text-align: left;
}
.modal-table.-striped-col td:nth-child(odd) {
    background-color: #f0f7fc;
}
.modal-table.-striped-col td {
    border: 1px solid #e4eef6;
    font-weight: 400;
    line-height: 1.57143;
    padding: 8px;
    vertical-align: middle;
}
.markDialog {
  max-height: 700px;
  min-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.markDialog::-webkit-scrollbar {
    width: 4px;
  }
.markDialog::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  /* background: fade(#409EFF, 60%); */
}
.markDialog::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* background: fade(@primary-color, 30%); */
}
</style>

 


// WEBPACK FOOTER //
// src/views/mark/markList.vue